import ExpandableSection from "@cloudscape-design/components/expandable-section"
import FieldCommentControl from "../comments/FieldCommentControl"

interface CollapsibleSectionProps {
  title: string
  description?: string
  defaultOpen?: boolean
  /**
   * Optional comment anchor (section_reference). When set, an inline comment control appears in the
   * section header so users can start/read a discussion scoped to this section.
   */
  commentAnchor?: string
  children: React.ReactNode
}

export const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  description,
  defaultOpen = true,
  commentAnchor,
  children,
}) => {
  return (
    <ExpandableSection
      variant="container"
      headerText={title}
      headerDescription={description}
      headerActions={
        commentAnchor ? (
          <FieldCommentControl anchor={commentAnchor} label={title} inline />
        ) : undefined
      }
      defaultExpanded={defaultOpen}
    >
      {children}
    </ExpandableSection>
  )
}
